export const EVEREST_SLIM_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@id": "https://everest.ind.br/#organization",
   "@type": "Organization",
   "name": "Everest",
   "url": "https://everest.ind.br",
   "logo": {
    "@type": "ImageObject",
    "url": "https://www.everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/produto/everest-slim#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Produtos",
     "item": "https://everest.ind.br/pt/produto"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Purificador de Água Everest Slim",
     "item": "https://everest.ind.br/pt/produto/everest-slim"
    }
   ]
  },
  {
   "@type": "Product",
   "@id": "https://everest.ind.br/pt/produto/everest-slim#product",
   "name": "Purificador de Água Everest Slim",
   "description": "O purificador mais fino da linha Everest, com refrigeração por compressor. Design compacto e elegante, ideal para residências, pequenos comércios e escritórios com espaço reduzido. Fornece água gelada, natural ou misturada para até 15 pessoas por hora. Instalação em bancada ou parede.",
   "url": "https://everest.ind.br/pt/produto/everest-slim",
   "image": [
    "https://assets.everest.ind.br/images/prata_e_branco_slim.original.png"
   ],
   "brand": {
    "@type": "Brand",
    "name": "Everest"
   },
   "manufacturer": {
    "@id": "https://everest.ind.br/#organization"
   },
   "model": "Everest Slim",
   "mpn": "EVEREST-SLIM",
   "category": "Casa > Purificador de Água",
   "color": "Branco, Preto, Prata, Cereja",
   "material": "Aço galvanizado, Polipropileno, Cobre, Poliuretano, Latão, Aço inoxidável",
   "audience": {
    "@type": "Audience",
    "audienceType": "Uso residencial e comercial em espaços pequenos"
   },
   "additionalProperty": [
    {
     "@type": "PropertyValue",
     "name": "Sistema de refrigeração",
     "value": "Compressor"
    },
    {
     "@type": "PropertyValue",
     "name": "Temperatura média da água gelada",
     "value": "8°C"
    },
    {
     "@type": "PropertyValue",
     "name": "Capacidade de refrigeração",
     "value": "1,8 litros/hora (ambiente 32°C, água 27°C)"
    },
    {
     "@type": "PropertyValue",
     "name": "Armazenamento de água gelada",
     "value": "1,8 litros"
    },
    {
     "@type": "PropertyValue",
     "name": "Capacidade de atendimento",
     "value": "Até 15 pessoas por hora"
    },
    {
     "@type": "PropertyValue",
     "name": "Vida útil do refil",
     "value": "4.000 litros (9 a 12 meses)"
    },
    {
     "@type": "PropertyValue",
     "name": "Temperatura de trabalho",
     "value": "5°C a 42°C"
    },
    {
     "@type": "PropertyValue",
     "name": "Pressão da rede hidráulica",
     "value": "3 a 40 MCA (0,029 a 0,392 MPa)"
    },
    {
     "@type": "PropertyValue",
     "name": "Tensão",
     "value": "127V ou 220V – 60Hz"
    },
    {
     "@type": "PropertyValue",
     "name": "Consumo",
     "value": "100W"
    },
    {
     "@type": "PropertyValue",
     "name": "Instalação",
     "value": "Bancada ou Parede"
    },
    {
     "@type": "PropertyValue",
     "name": "Altura",
     "value": "36 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Largura",
     "value": "27,5 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Profundidade",
     "value": "37 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Peso",
     "value": "11 kg"
    },
    {
     "@type": "PropertyValue",
     "name": "Certificação",
     "value": "INMETRO, ABRAFIPA"
    }
   ],
   "offers": {
    "@type": "Offer",
    "priceCurrency": "BRL",
    "price": "1329.05",
    "availability": "https://schema.org/InStock",
    "url": "https://everest.ind.br/pt/produto/everest-slim",
    "seller": {
     "@id": "https://everest.ind.br/#organization"
    }
   },
   "potentialAction": {
    "@type": "ViewAction",
    "target": "https://everest.ind.br/pt/produto/everest-slim"
   }
  }
 ]
}
